import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight, FiDownload } from 'react-icons/fi';
import { FaLinkedinIn, FaGithub, FaWhatsapp, FaDev } from 'react-icons/fa';
import SplitText from '../ui/SplitText';
import Reveal from '../ui/Reveal';
import Magnetic from '../ui/Magnetic';
import { profile } from '../../data/profile';
import useDubaiTime from '../../hooks/useDubaiTime';
import './Contact.css';

const socials = [
  { label: 'LinkedIn', href: profile.links.linkedin, Icon: FaLinkedinIn },
  { label: 'GitHub', href: profile.links.github, Icon: FaGithub },
  { label: 'dev.to', href: profile.links.devto, Icon: FaDev },
  { label: 'WhatsApp', href: profile.links.whatsapp, Icon: FaWhatsapp },
];

export default function Contact() {
  const time = useDubaiTime(false);
  const year = new Date().getFullYear();

  return (
    <footer className="contact" id="contact">
      <div className="contact__glow" aria-hidden />
      <div className="container">
        <Reveal className="section-head__meta" y={12}>
          <span className="index">08</span>
          <span className="label">Contact</span>
        </Reveal>

        <SplitText
          as="h2"
          className="display contact__title"
          inView
          stagger={0.05}
          text={[
            { text: 'Let’s build something' },
            { br: true },
            { text: 'that', em: false },
            { text: 'holds up.', em: true },
          ]}
        />

        <Reveal className="contact__row" delay={0.2}>
          <p className="lead contact__lead">
            {profile.availability}. If you are shipping an AI product and the backend is the part that scares you,
            I would like to hear about it.
          </p>
          <div className="contact__actions">
            <Magnetic>
              <a href={profile.links.email} className="btn btn--primary">
                {profile.email} <span className="btn__icon"><FiArrowUpRight /></span>
              </a>
            </Magnetic>
            <Magnetic>
              <a href={profile.cv} className="btn btn--ghost" download="Ayaan_Ahmad_CV.pdf">
                CV <span className="btn__icon"><FiDownload /></span>
              </a>
            </Magnetic>
          </div>
        </Reveal>

        <Reveal className="contact__socials" delay={0.3}>
          {socials.map(({ label, href, Icon }, i) => (
            <Magnetic key={label} strength={0.25}>
              <motion.a
                href={href}
                target="_blank"
                rel="noreferrer"
                className="contact__social"
                aria-label={label}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.35 + i * 0.07, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              >
                <Icon />
                <span>{label}</span>
              </motion.a>
            </Magnetic>
          ))}
        </Reveal>

        <div className="contact__foot">
          <span className="mono">&copy; {year} {profile.name}</span>
          <span className="mono contact__foot-time">
            <span className="dot-live" /> Dubai, {time} GST
          </span>
          <span className="mono">Designed &amp; built with React + Framer Motion</span>
        </div>
      </div>
    </footer>
  );
}
